import React from 'react';
import PropTypes from 'prop-types';
import { Building2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../../components/ui/card';
import { Checkbox } from '../../../../../components/ui/checkbox';
import { ScrollArea } from '../../../../../components/ui/scroll-area';
import { cn } from '../../../../../lib/utils';

function DepartmentFilter({ departments, selectedDepartments, onFilterChange }) {
  const handleCheckboxChange = (departmentId) => {
    onFilterChange(departmentId);
  };

  return (
    <Card className="w-48 shrink-0 h-fit" style={{ border: '1px solid hsl(var(--border))' }}>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          Departments
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <ScrollArea className="max-h-64">
          <div className="space-y-1">
            {departments.map((department) => {
              const isSelected = selectedDepartments.includes(department._id);
              return (
                <button
                  key={department._id}
                  type="button"
                  onClick={() => handleCheckboxChange(department._id)}
                  className={cn(
                    'w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-sm transition-colors',
                    'hover:bg-accent hover:text-accent-foreground',
                    isSelected && 'bg-primary/10',
                  )}
                >
                  <Checkbox
                    checked={isSelected}
                    onCheckedChange={() => handleCheckboxChange(department._id)}
                    className="pointer-events-none"
                  />
                  <span className="truncate">{department.title}</span>
                </button>
              );
            })}
          </div>
        </ScrollArea>

        {selectedDepartments.length > 0 && (
          <div className="mt-3 pt-3 border-t border-border">
            <p className="text-xs text-muted-foreground">{selectedDepartments.length} selected</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

DepartmentFilter.propTypes = {
  departments: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedDepartments: PropTypes.arrayOf(PropTypes.string).isRequired,
  onFilterChange: PropTypes.func.isRequired,
};

export default DepartmentFilter;
